module.exports = __webpack_public_path__ + "img/melissa-recibos3.a730f0fa.png";